import { ApolloError, gql } from '@apollo/client';
import {
  Button,
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { LazyUrlModal } from 'src/components/common/LazyUrlModal';
import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';
import Config from 'src/lib/config';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { setOverlayVisibleLocation } from 'src/lib/routing';

import { DeleteGraphConfirmationModal } from './DeleteGraphConfirmationModal';

export const DeleteGraphCardServiceFragment = gql`
  fragment DeleteGraphCardServiceFragment on Service {
    id
    title
    variants {
      id
      name
      usageLastReportedAt
      activeSchemaPublish {
        id
        publishedAt
      }
    }
    account {
      id
    }
  }
`;

interface Props {
  service: GraphQLTypes.DeleteGraphCardServiceFragment;
  setError: (e: ApolloError) => void;
}
export const DeleteGraphCard = ({ service, setError }: Props) => {
  const location = useLocation();
  if (!service.account)
    throw new Error('Current Graph has no owner Organization.');

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Delete graph</CardTitle>
          <CardDescription>
            Deleting <b>{service.title}</b> will remove it from Studio.
          </CardDescription>
          <PermissionWarning
            graphId={service.id}
            graphPermissions="canDelete"
            childRenderer={(hasPermission) => (
              <Button
                as={Link}
                variant="destructive"
                isDisabled={!hasPermission}
                to={setOverlayVisibleLocation({
                  location,
                  overlayName: Config.modals.deleteGraph,
                })}
              >
                Delete graph
              </Button>
            )}
          />
        </CardHeader>
      </Card>
      <LazyUrlModal name={Config.modals.deleteGraph}>
        {({ closeModal, isOpen }) => (
          <DeleteGraphConfirmationModal
            service={service}
            isOpen={isOpen}
            onClose={closeModal}
            setGeneralError={setError}
          />
        )}
      </LazyUrlModal>
    </>
  );
};
